import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { apiLogin, apiRegister, apiMe, apiLogout, getToken } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (getToken()) {
        const current = await apiMe();
        setUser(current);
      }
      setLoading(false);
    })();
    // apiMe & getToken are stable module imports; intentionally run once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refresh = useCallback(async () => {
    const current = await apiMe();
    setUser(current);
    return current;
  }, []);

  const doLogin = useCallback(async (email, password) => {
    const res = await apiLogin(email, password);
    if (res.user) setUser(res.user);
    return res;
  }, []);

  const doRegister = useCallback(async (data) => {
    const res = await apiRegister(data);
    if (res.user) setUser(res.user);
    return res;
  }, []);

  const doLogout = useCallback(() => {
    apiLogout();
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, loading, doLogin, doRegister, doLogout, refresh }),
    [user, loading, doLogin, doRegister, doLogout, refresh]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
